import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCMoPz_h1cbbJ_d00lfHrwn2dSXjklImjs",
  authDomain: "clone-5bbc0.firebaseapp.com",
  projectId: "clone-5bbc0",
  storageBucket: "clone-5bbc0.appspot.com",
  messagingSenderId: "361611376680",
  appId: "1:361611376680:web:70757047a83c323105dd1d",
  measurementId: "G-ZVLPY1C6P6",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
const db = firebaseApp.firestore();

export default db;
